// Bietet angemeldeten Benutzern die freiwillige TOTP-Einrichtung im eigenen Profil an.
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { Button, Paper, Typography } from "@material-ui/core";

import { confirmTotpEnrollment } from "../../auth/authApi";
import { UserContext } from "../../contexts/UserContext";
import TotpEnrollment from "./TotpEnrollment";

const profileRoles = ["administrator", "agent", "tippgeber", "backoffice"];

const MfaProfileSettings = () => {
	const userContext = useContext(UserContext);
	const [status, setStatus] = useState(null);
	const [enrollment, setEnrollment] = useState(null);
	const [processing, setProcessing] = useState(false);
	const [error, setError] = useState(false);
	const mounted = useRef(false);

	useEffect(() => {
		mounted.current = true;
		return () => { mounted.current = false; };
	}, []);

	useEffect(() => {
		if (!profileRoles.includes(userContext.user.role)) return;
		let active = true;
		axios({
			url: `${process.env.REACT_APP_API_SERVICE_URL}/auth/mfa/status`,
			method: "get",
			headers: userContext.getRequestAuthHeader()
		})
			.then((response) => { if (active) setStatus(response.data); })
			.catch(() => { if (active) setStatus({ enabled: false }); });
		return () => { active = false; };
	}, [userContext.user.role]);

	if (!profileRoles.includes(userContext.user.role) || !status || !status.enabled) {
		return null;
	}

	const startEnrollment = () => {
		setProcessing(true);
		setError(false);
		axios({
			url: `${process.env.REACT_APP_API_SERVICE_URL}/auth/mfa/enrollment`,
			method: "post",
			headers: userContext.getRequestAuthHeader()
		})
			.then((response) => { if (mounted.current) setEnrollment(response.data); })
			.catch(() => { if (mounted.current) setError(true); })
			.finally(() => { if (mounted.current) setProcessing(false); });
	};

	const confirmEnrollment = (code) => {
		setProcessing(true);
		setError(false);
		return confirmTotpEnrollment(enrollment.challenge_id, code)
			.then((response) => {
				if (!mounted.current) return;
				setEnrollment(null);
				setStatus({ ...status, status: "active" });
				setProcessing(false);
				// Adopting the new session can unmount this profile immediately.
				userContext.completeOptionalMfaEnrollment(response.data);
			})
			.catch(() => {
				if (!mounted.current) return;
				setError(true);
				setProcessing(false);
			});
	};

	return <Paper style={{ padding: 16, marginTop: 20, marginBottom: 16 }}>
		{status.status === "active" ? <>
			<Typography variant="h5">Zwei-Faktor-Anmeldung</Typography>
			<Typography>Die Zwei-Faktor-Anmeldung ist für dieses Konto eingerichtet.</Typography>
		</> : enrollment ?
			<TotpEnrollment
				enrollment={enrollment}
				processing={processing}
				error={error}
				onSubmit={confirmEnrollment}
			/> : <>
			<Typography variant="h5">Zwei-Faktor-Anmeldung</Typography>
			<Typography paragraph>
				Schütze dein Konto freiwillig mit einem zusätzlichen sechsstelligen Authenticator-Code.
			</Typography>
			<Button
				variant="contained"
				color="primary"
				disabled={processing}
				onClick={startEnrollment}
			>
				Zwei-Faktor-Anmeldung einrichten
			</Button>
			{error && <Typography color="error">Einrichtung konnte nicht gestartet werden.</Typography>}
		</>}
	</Paper>;
};

export default MfaProfileSettings;
